<template lang="pug">
div.scene
  .topTitle
    span {{form.departmentName == "UNITA"?"部门1":form.departmentName}}
    .btns
      span.span(@click='chagneImage') 更换场景
      Icon(type="md-arrow-dropup",@click="$emit('upData',eachIndex,DATA,)")
      Icon(type="md-arrow-dropdown",@click="$emit('downData',eachIndex,DATA)")
      Icon(type="md-git-branch",@click='logic')
      Icon(type="ios-trash",@click='delModel')
  .talkImg
    img(:src="getImgPath()")
  .plan
    Form(ref="department",:model="form",:label-width="120")
      FormItem(label="设置部门名称")
        Select(ref="element",v-model="form.departmentName" placeholder="选择部门名称",@on-change="select")
          Option(v-for="(item, index) in departmentList",
            :key="item.id || index"
            :value="item.departmentName",
            ) {{item.departmentName}}
  component(v-for='(item,index) in assemblyList',
    v-if="condition"
    :key='index',
    :assemblyName="assemblyName",
    @delModel='delCom(index)',
    :ref="item.name + index",
      v-disabled="seeState"
    :is='item.name',
    :data='item.data',
    :ha-id="haId"
    :task-id="taskId"
    :enableAI="enableAI"
    @upData='upData(index)',
    @downData='downData(index)',
    @data1:data="val => item.data = val"
    :uploadData.sync="uploadData").model
  div.drag(@drop="fun_drop",@dragover="allowDrop")
    p  把题型或者案例内容拖入此区域吧!
  Modal.modal1(:value="modal1" :closable='true' width='680' :mask-closable="true" :footer-hide='true',@on-visible-change="choseImg")
    .imglist
      .imgview(
        v-for='(item, index) in unitList'
        :key="item"
        @click='activeImg(item)'
      )
        .mask 场景{{index + 1}}
        div(v-if='item === name' :class='item === name ? "check" : ""') √
        img.img(:src='getImgPath(index)')
</template>
<script>
import mybus from "@/utils/main";
import Single from "../case/single";
import MultipleA from "../case/multiple";
import MultipleB from "../case/multiple";
import Fillblank from "../case/fillblank";
import EasyQuestion from "../case/easyQuestion";
import Material from "../case/material";
import CaseTitle from "../case/caseTitle";
import CaseAxis from "../case/caseAxis";
import CaseDialogue from "../case/caseDialogue";
import CaseAskAndAnswer from "../case/caseAskAndAnswer";
import CaseGuide from "../case/caseGuide";
import CasePhotoText from "../case/casePhotoText";
import CaseSingleText from "../case/caseSingleText";
import CaseInfoBase from "../case/caseInfoBase";
import CaseDepartment from "../case/caseDepartment";
import CaseUpload from "../case/caseUpload";
import determineQuestion from "../case/determineQuestion";
import ligatureQuestion from "../case/ligatureQuestion";
import TableQuestion from "../case/tableQuestion";
import CaseTitleText from "../case/caseTitleText";
import CaseVideo from "../case/caseVideo";
import MultipeChoice from "../case/multipeChoice";
import Divider from "../case/divider";
import smallCaseTitle from "../case/smallCaseTitle";

/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import { unitList, caseList } from "./departmentImage";

export default {
  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    EasyQuestion,
    Material,
    CaseAxis,
    CaseTitle,
    CaseDialogue,
    CaseAskAndAnswer,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    determineQuestion,
    TableQuestion,
    ligatureQuestion,
    CaseGuide,
    CasePhotoText,
    CaseSingleText,
    CaseTitleText,
    CaseVideo,
    MultipeChoice,
    Divider,
    smallCaseTitle
  },
  inject: ["seeState"],

  props: ["assemblyName", "eachIndex", "selectDepartment1", "data", "info", "fun_office1", "name", "taskId", "haId", "taId", "cdId"],
  data() {
    return {
      condition: true,
      unit: "",
      form: {
        departmentName: "",
        logic: ""
      },
      department1: "",
      departmentCode: "",
      fun_office: "",
      departmentList: [],
      assemblyList: [], // 拖进来的组件
      unitList,
      caseList,
      modal1: false /** 场景图 */,
      taskHome: [],
      uploadData: {},
      enableAI: false,
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  watch: {
    uploadData: {
      handler(val) {
        console.log(val, "uploadData");
        this.$emit("updateUploadData", val);
      },
      deep: true
    },
    haId(newVal) {
      if (!newVal) {
        this.initHaId();
      }
    }
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    getImgPath() {
      // console.log(this.name, "nameeeee"); src="../../assets/case/department/scene.png"
      return i => {
        if (i || i === 0) {
          return require(`../../assets/case/${this.caseList[i]}.png`);
        }
        const a = require(`../../assets/case/${this.caseList[this.unitList.indexOf(this.name)]
          }.png`);
        // console.log(a, "../../assets/case/");
        return a;
      };
    },
    DATA() {
      return { talkList: this.form, assemblyList: this.assemblyList };
    },
    List() {
      return this.getData;
    },
    taskList() {
      return this.$store.state.task.task;
    },
    // taskHome() {
    //   let arr = [];
    //   this.$http.getCaseHallNavbarList(this.$store.state.Case.basic.id).then(res => {
    //     arr = this.$store.state.Case.caseData[
    //       res.data.data[+sessionStorage.getItem("CaseStage") - 1]
    //     ].taskHome;
    //   });
    //   return arr;
    // },
    ChId() {
      return this.$store.state.Case.chId;
    }
  },
  created() {
    if (this.data) {
      this.assemblyList = this.data.assemblyList || this.data;
    }
    // debugger;
    // setTimeout(() => {
    //  console.log("🚀 ~ created ~  this.assemblyList:", this.assemblyList, this.data);
    // }, 1000 * 15);

    this.form.departmentName = this.fun_office1 || "UNITA";
    this.fun_office = this.fun_office1;
  },
  methods: {
    async initHaId() {
      const index = +sessionStorage.getItem("CaseStage") - 1;
      const caseData = this.$store.state.Case.caseData?.[this.caseValue[index]];

      if (caseData?.HallId) {
        this.haId = caseData.HallId;
      } else {
        try {
          const res = await this.$http.getCasehallByPyIdAndCaseStep({
            pyId: this.Case?.basic?.id,
            caseStep: this.caseValue[index]
          });
          if (res.data.success) {
            this.haId = res.data.data.id;
          }
        } catch (e) {
          console.error("重新获取 haId 失败", e);
        }
      }
    },
    checkEnableAI() {
      this.$http
        .getEnableState()
        .then((res) => {
          if (res.data.success) {
            this.enableAI = res.data.data;
          } else {
            this.enableAI = false;
          }
        })
        .catch(() => {
          this.enableAI = false;
        });
    },
    activeImg(unit) {
      this.unit = unit;
      this.modal1 = false;
    },
    /** 点击图片modal */
    choseImg(val) {
      // console.log(val, "this.modal");
      if (!val) {
        this.modal1 = false;
      }
      if (this.unit) {
        const data = {
          type: "unit",
          index: this.eachIndex,
          data: {
            name: this.unit,
            DATA: this.DATA
          }
        };
        this.$emit("changeData", data);
      }
    },
    /** 更换场景modal */
    chagneImage() {
      this.modal1 = true;
      console.log(this.modal1, this.unit, "name", "eachIndex");
    },
    upData(index) {
      // 题目点击向上移动
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    downData(index) {
      // 题目点击向上移动

      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    select(value) {
      let i;
      // 截流
      let lock = 0;
      this.taskList.forEach(item => {
        if (item.departmentName) {
          if (item.departmentName === value) {
            // 清空内容
            this.form.departmentName = "";
            this.$refs.element.values = [];
            lock = 1;
            return this.$Message.error("不可以选择相同的部门");
          }
        }
      });
      if (lock > 0) {
        return;
      }
      this.taskHome.forEach(item => {
        // console.log(item);
        if (item.departmentName === value) {
          const obj = {};
          obj.departmentName = item.departmentName;
          obj.cdId = item.id || item.chId;
          i = obj;
        }
      });
      const obj1 = {};
      obj1.index = this.eachIndex;
      obj1.departmentName = value;
      this.fun_office = value;
      // console.log(i, "oldIs");
      this.$emit("info:data", i, this.eachIndex);
      this.$store.commit("changeFunc", obj1);
    },
    getData(data) {
      return data;
    },
    // 删除题目
    delCom(index) {
      // delete this.assemblyList[index];
      if (!this.assemblyList[index].data || !this.assemblyList[index].data.id) {
        this.assemblyList.splice(index, 1);
        return;
      }
      if (this.assemblyList[index].data.id) {
        /** 如果有ID 则需要调用后端接口 */
        this.$store.commit("deleteControl", this.assemblyList[index].data.id);
      }
      // 直接删除
      this.assemblyList.splice(index, 1);
      const obj = {};
      obj.type = this.department1;
      obj.deleteIndex = index;
      this.$store.commit("deleteQues", obj);
    },
    async getPersion() {
      try {
        const { data } = await this.$http.listCaseDepartmentStepByChid({
          chId: this.ChId
        });
        const { data: navD } = await this.$http.getCaseHallNavbarList(
          this.$store.state.Case.basic.id
        );
        const data2 = await {
          index: navD.data.sort((a, b) => a.sortNo - b.sortNo)[
            +sessionStorage.getItem("CaseStage") - 1
          ].caseStep,
          taskHome: data.data
        };
        this.taskHome = data.data;
        this.$store.commit("postcaseHome", data2);
        this.departmentList = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // 删除部门
    delModel() {
      this.$emit("delModel", this.name, this.eachIndex);
    },
    fun_drop() {
      console.log("🚀 ~ fun_drop ~ assemblyName:", this.assemblyName);
      if (this.assemblyName !== "") {
        this.assemblyList.push({ name: this.assemblyName, data: {} });
        const obj = {};
        obj.type = this.department1;
        obj.listChild = this.assemblyName;
        this.$store.commit("addQues", obj);
      } else if (this.assemblyName === "TableQuestion") {
        // return this.$Message.error("禁止添加表格题");
      }
    },
    allowDrop(e) {
      e.preventDefault();
    }
  },
  mounted() {
    this.checkEnableAI();
    this.haId =
      this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].HallId;
    this.getPersion();
    this.departmentCode = this.assemblyName;
    this.department1 = this.selectDepartment1;
    // this.departmentList = this.caseValue;
    this.$store.state.Case.caseData[
      this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
    ].taskHome.forEach(res => {
      console.log("🚀 ~ mounted ~ res:", res);

      if (
        res.departmentName !== "我的办公室" &&
        res.departmentName !== "领导办公室" &&
        res.departmentName !== "民意调查中心"
      ) {
        this.departmentList.push(res);
      }
    });
    // this.$store.state.Case.caseData.EXECUTE.taskHome.forEach(res => {
    //   if (
    //     res.departmentName !== "我的办公室" &&
    //     res.departmentName !== "领导办公室" &&
    //     res.departmentName !== "民意调查中心"
    //   ) {
    //     this.departmentList.push(res);
    //   }
    // });
    mybus.$on(`add${this.eachIndex}`, this.ObtainSubject);
  }
};
</script>

<style lang="stylus">
.scene
  width 854px
  padding 16px 32px 60px 32px
  .topTitle
    text-align left
    height 32px
    line-height @height
    position relative
    margin-bottom 16px
    font-size 14px
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    .btns
      position absolute
      right 0
      top 0
      .span
        padding-right 12px
        cursor pointer
      .ivu-icon
        color #3A76D2FF
        font-size 22px
        top 0
        margin-right 12px
        background #F2F5FAFF
        width 24px
        height 24px
        border-radius 4px
        text-align center
        line-height @height
        &:hover
          cursor pointer
  .talkImg
    margin-bottom 24px
    img
      width 100%
  .plan
    text-align left
    font-size 14px
    border-bottom 1px solid rgba(42, 46, 54, 0.3)
    form
      .ivu-form-item
        .ivu-form-item-label
          text-align left
        .ivu-form-item-content
          .ivu-select
            width 168px
  .drag
    min-width 790px
    height 100px
    background #fff
    border-radius 4px
    border 1px dashed rgba(128, 128, 128, 0.5)
    margin-top 24px
    cursor alias
    p
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 100px
      text-align center
.modal1
  .imglist
    display flex
    flex-direction row
    flex-wrap wrap
    .imgview
      position: relative;
      width 148px
      height 84px
      cursor pointer
      margin 4px
      .mask
        width 100%
        height 84px
        line-height 84px
        position absolute
        display block
        font-size 14px
        font-family MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI
        font-weight bold
        color #FFFFFF
        text-align center
        background rgba(0,0,0,0.4)
      .check
        position absolute
        top 5px
        right 5px
        width 20px
        height 20px
        line-height 24px
        background rgb(51,124,246)
        color #ffffff
        text-align center
        border-radius 50%
        border: 1px solid #ffffff;
      .img
        width 100%
        height 100%
      &:hover
        .mask
          display none
</style>
